import api from '../../../api/comptabilite/_configs'

const state = () => ({
    sfe_configs: [],
    sfe_type_facture: [],
    sfe_type_paiement: [],
    sfe_liste_aib: [],
    sfe_groupes_taxation: [],

    config_info_clinique: [],
    divers_info: [],
    liste_bon_consommables: [],
})

// getters
const getters = {
    sfe_configs: (state) => {
        return state.sfe_configs
    },

    sfe_type_facture: (state) => {
        return state.sfe_type_facture
    },

    sfe_type_paiement: (state) => {
        return state.sfe_type_paiement
    },

    sfe_liste_aib: (state) => {
        return state.sfe_liste_aib
    },

    sfe_groupes_taxation: (state) => {
        return state.sfe_groupes_taxation
    },

    config_info_clinique: (state) => {
        return state.config_info_clinique
    },

    divers_info: (state) => {
        return state.divers_info
    },

    liste_bon_consommables: (state) => {
        return state.liste_bon_consommables
    },
}

// mutations
const mutations = {
    SET_SFE_CONFIGS(state, info) {
        state.sfe_configs = info
    },

    SET_CONFIG_INFO_DIVERS(state, info) {
        state.divers_info = info
    },

    SET_CONFIG_BON_CONSOMMABLE(state, conso) {
        state.liste_bon_consommables = conso
    },

    SET_CONFIG_INFO_CLINIQUE(state, info) {
        state.config_info_clinique = info
    },

    SET_SFE_TYPE_FACTURE(state, info) {
        state.sfe_type_facture = info
    },

    SET_SFE_TYPE_PAIEMENT(state, info) {
        state.sfe_type_paiement = info
    },

    SET_SFE_LISTE_AIB(state, info) {
        state.sfe_liste_aib = info
    },

    SET_SFE_GROUPES_TAXATION(state, info) {
        state.sfe_groupes_taxation = info
    },
}

// actions
const actions = {
    getConfigInfoClinique({commit}, data_type){
        return new Promise((resolve,reject) => {
            api.getConfigInfoClinique(data_type).then(
                response => {
                    if (data_type == 'info_clinique') {
                        commit('SET_CONFIG_INFO_CLINIQUE', response)
                    } else if (data_type == 'divers_info') {
                        commit('SET_CONFIG_INFO_DIVERS', response)
                    } else if (data_type == 'bon_consommable') {
                        commit('SET_CONFIG_BON_CONSOMMABLE', response)
                    } else if (data_type == 'info_sfe') {
                        commit('SET_SFE_CONFIGS', response)
                    }
                    
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    getInfoSFE({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getInfoSFE(data).then(
                (response) => {
                    if (data.data_type === 'invoice_type') {
                        commit("SET_SFE_TYPE_FACTURE", response);
                    } else if (data.data_type === 'payment_type') {
                        commit("SET_SFE_TYPE_PAIEMENT", response);
                    } else if (data.data_type === 'aib_type') {
                        commit("SET_SFE_LISTE_AIB", response);
                    } else if (data.data_type === 'taxation_type') {
                        commit("SET_SFE_GROUPES_TAXATION", response);
                        commit("SET_SFE_LISTE_AIB", response); // done by intention not to change a lot of code
                    }
                    
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions
}